var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "route-importer-container" },
    [
      _c("map-form-btn", {
        staticClass: "route-importer-btn",
        attrs: {
          icon: "cloud_upload",
          title: _vm.$t("routeImporter.loadRouteFile")
        },
        on: {
          clicked: function($event) {
            return _vm.openImporter()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: true, attach: "body" },
          model: {
            value: _vm.isImportModalOpen,
            callback: function($$v) {
              _vm.isImportModalOpen = $$v
            },
            expression: "isImportModalOpen"
          }
        },
        [
          _c(
            "box",
            {
              attrs: {
                customClass: "route-importer-modal",
                background: "white",
                closable: ""
              },
              on: {
                closed: function($event) {
                  return _vm.closeImporter()
                }
              },
              model: {
                value: _vm.isImportModalOpen,
                callback: function($$v) {
                  _vm.isImportModalOpen = $$v
                },
                expression: "isImportModalOpen"
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(_vm._s(_vm.$t("routeImporter.loadRouteFile")))
              ]),
              _vm._v(" "),
              _c("vue-dropzone", {
                ref: "importRouteDropzone",
                attrs: { id: "dropzone", options: _vm.dropzoneOptions },
                on: { "vdropzone-file-added": _vm.fileAdded }
              }),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticStyle: { color: "white" },
                  attrs: { value: true, type: "info" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("routeImporter.acceptedImportTypes")) +
                      ": "
                  ),
                  _c("b", [_vm._v("ors-json")]),
                  _vm._v(", "),
                  _c("b", [_vm._v("geojson")]),
                  _vm._v(", "),
                  _c("b", [_vm._v("kml")]),
                  _vm._v(" " + _vm._s(_vm.$t("global.and")) + " "),
                  _c("b", [_vm._v("gpx")])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-619d2cc7", { render: render, staticRenderFns: staticRenderFns })
  }
}